import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { filter } from 'rxjs/operators';
import { TextMaskConfig } from "angular2-text-mask";
import { Utils } from "../../classes";
import { WebsocketService } from '../../services/websocket.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  form = new FormGroup({
    numbercard: new FormControl('', [Validators.required]),
    pincode: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    passwordConfirm: new FormControl('', [Validators.required, this.passwordConfirmValidate().bind(this)])
  });
  passwordVisible = false;
  passwordMask = new Array(140).fill(/[^А-яЁё]/);
  serverError: string = '';
  processing = false;
  /*textMask: TextMaskConfig = {
    mask: ['0-9','1-3','.','0-1','1-9','.','0-9','0-9','0-9','0-9']
  };*/

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private websocket: WebsocketService
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams?.logout) {
      this.websocket.destroy();
      this.authService.logout();
    }

    this.form.valueChanges.pipe(filter(() => !!this.serverError.length)).subscribe(item => {
      this.serverError = '';
    })
  }

  passwordReset() {
    this.form.controls.password.setValue('');
    this.form.controls.password_confirm.setValue('');
  }
  auth() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const form = this.form.getRawValue();
    const date = new Date(form.birthdate);
    const data = {
      CardNumber : form.numbercard,
      CardPinCode: form.pincode,
      ConvictedPassword: form.password,
    }
    this.authService.registration(data).subscribe(item => {
      this.router.navigate(['']);
      this.processing = false;
    }, error => {
      this.serverError = error.error.detail;
      this.processing = false;
    })
  }

  passwordConfirmValidate(): ValidatorFn {
    return (control: AbstractControl) => {
    if (!control.value || !control.parent?.get('password')?.value) {
      return null;
    }
    const isValid = control.value === control.parent?.get('password')?.value;
    return isValid ? null : { passwordConfirm: true };
    }
  }
}
